<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">审核管理</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">直播课程审核</a>
        </span>
      </div>
      <div class="framePage-body">
        <el-tabs v-model="activeName" :before-leave="beforeTabLeave" @tab-click="tabsChange">
          <el-tab-pane label="待审核" name="first">
            <liveClassFestivalToBeReviewed :name="activeName" ref="first" />
          </el-tab-pane>
          <el-tab-pane label="已通过" name="second">
            <liveClassFestivalToBeReviewed :name="activeName" ref="second" />
          </el-tab-pane>
          <el-tab-pane label="已驳回" name="three">
            <liveClassFestivalToBeReviewed :name="activeName" ref="three" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import List from "@/mixins/List";
import liveClassFestivalToBeReviewed from "@/views/liveBroadcastManagement/liveClassFestivalReview/liveClassFestivalToBeReviewed.vue";
import { resetKeepAlive } from "@/utils/common";
export default {
  name: "liveClassReview",
  components: {
    liveClassFestivalToBeReviewed
  },
  mixins: [List],
  data() {
    return {
      activeName: ""
    };
  },
  created() {
    this.activeName = this.$route.query.active || "first";
    // this.name = this.$route.query.name || "first";
  },
  mounted() {
    if (this.$route.query.active == "second") {
      this.$refs["second"].getData(
        -1,
        "/biz/live/course/auditPassedList",
        "second"
      );
    } else if (this.$route.query.active == "three") {
      this.$refs["three"].getData(
        -1,
        "/biz/live/course/auditNotPassedList",
        "three"
      );
    } else {
      this.$refs["first"].getData(
        -1,
        "/biz/live/course/waitAuditList",
        "first"
      );
    }
  },
  methods: {
    beforeTabLeave(newName) {
      this.$router.replace({
        path: this.$route.path,
        query: { active: newName }
      });
    },
    tabsChange(e) {
      this.activeName = e.name;
      this.name = e.name;
      if (e.name == "second") {
        this.$refs.second.getData(1, "/biz/live/course/auditPassedList", e.name);
      } else if (e.name == "three") {
        this.$refs.three.getData(1, "/biz/live/course/auditNotPassedList", e.name);
      } else {
        this.$refs.first.getData(1, "/biz/live/course/waitAuditList", e.name);
      }
      this.$refs[e.name].liveCourseName = '';
      this.$refs[e.name].getData(-1);
    }
  },
  beforeRouteLeave: resetKeepAlive,
  watch: {
    $route: function(route) {
      if (route.query.refresh) {
        this.$refs[route.query.active].getData(-1);
      }
    }
  }
  
};
</script>
<style lang="less">
.qrcode {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 400px;
    height: 400px;
    background-color: #999; //设置白色背景色
  }
}
.searchBox {
  .el-icon-arrow-down:before {
    content: "\e6df" !important;
  }
}
</style>
